import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { Button, Dropdown, Table } from "react-bootstrap";
import ReactDatePicker from "react-datepicker";
import { withTranslation } from "react-i18next";
import { BsThreeDots } from "react-icons/bs";
import { LoaderContext, RegulationContext } from "../../../App";
import { LS_AUTHORITY_KEY } from "../../../core/constants/common";
import KPIService from "../../../core/service/KPIService";
import UserService from "../../../core/service/UserService";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";

const KPIActionsView = ({ t, filter }) => {

	const lsData = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
	const companyId = lsData.profile.company.id;
	const { glbRegulation } = useContext(RegulationContext);
	const glbRegulationId = glbRegulation?.id ?? "";
	const { setLoaderDisplay } = useContext(LoaderContext);
	const [actions, setActions] = useState([]);
	const [actionProgressData, setActionProgressData] = useState([]);
	const [editedAction, setEditedAction] = useState({});
	const [users, setUsers] = useState([]);
	const [editedProgress, setEditedProgress] = useState({ id: -1 });
	const [progressTodelete, setProgressToDelete] = useState({});

	useEffect(() => {
		fetchActions(filter);
		fetchUsers();
	}, [filter]);

	useEffect(() => {
		if (!editedAction?.id) return;

		fetchActionProgress(editedAction.id);
	}, [editedAction?.id]);

	const fetchActions = (filter) => {
		setLoaderDisplay(true);
		KPIService.filterActions({
			ownerId: companyId,
			category: filter.kpiCategory,
			goalId: filter.goalId,
			kpiId: filter.kpiId,
			assigneeId: filter.assigneeId
		}).then(res => {
			setLoaderDisplay(false);
			if (res.status !== 200) return;

			setActions(res.data.data ?? []);
			fetchActionProgress(res.data.data[0]?.id);
			setEditedAction(res.data.data[0]);

		}).catch(err => { setLoaderDisplay(false); });
	};

	const fetchActionProgress = (actionId) => {
		KPIService.getActionProgress(actionId).then(res => {
			if (res.status !== 200) return;

			setActionProgressData(res.data.data ?? []);
		}).catch(err => { });
	};

	const fetchUsers = () => {
		UserService.getUsers(0, 10, '', '', true).then((res) => {
			if (res.status !== 200) return;

			setUsers(res.data);
		})
			.catch((error) => {
			});
	};

	const renderDateField = () => {
		return (
			<ReactDatePicker
				selected={editedProgress.date ? new Date(editedProgress.date) : null}
				onChange={(date) => {
					setEditedProgress({
						...editedProgress,
						date: moment(date).format('YYYY-MM-DD')
					});
				}}
				className="form-control"
				dateFormat="dd/MM/yyyy"
				required />
		);
	};

	const renderProgressPercField = () => {
		return (
			<input
				type="number"
				className="form-control"
				onChange={(e) => setEditedProgress({ ...editedProgress, progress: +e.target.value })}
				value={editedProgress.progress}
				required />
		);
	};

	const renderCommentField = () => {
		return (
			<input
				type="text"
				className="form-control"
				onChange={(e) => setEditedProgress({ ...editedProgress, comment: e.target.value })}
				value={editedProgress.comment}
				required />
		);
	};

	const renderUserSelector = () => {
		return (
			<select className="form-select"
				value={editedProgress.userId}
				onChange={(e) => setEditedProgress({
					...editedProgress,
					userId: +e.target.value,
					username: users?.find(u => u.id === +e.target.value)?.name ?? ''
				})}>
				<option value='' key=''>{t("Select.label")}</option>
				{
					users?.map((u) => (
						<option value={u.id} key={u.id}>{u.name}</option>
					))
				}
			</select>
		);
	};

	const renderProgressRowInEditMode = (pIndex) => {
		return (
			<tr key={`actionProgressRow-${pIndex}`}>
				<td>{renderDateField()}</td>
				<td>{renderProgressPercField()}</td>
				<td>{renderCommentField()}</td>
				<td>{renderUserSelector()}</td>
				<td>
					<div className="d-flex">
						<Button variant="primary" className="mx-1" onClick={() => upsertProgress()}>{t('Save.label')}</Button>
						<Button variant="secondary" className="mx-1" onClick={() => setEditedProgress({ id: -1 })}>{t('Cancel.label')}</Button>
					</div>
				</td>
			</tr>
		);
	};

	const renderNewProgressRow = () => {
		return (
			<tr key={`actionProgressNewRow`}>
				<td>{editedProgress.id === 0 && renderDateField()}</td>
				<td className="ActionProgressbox">{editedProgress.id === 0 && renderProgressPercField()}</td>
				<td>{editedProgress.id === 0 && renderCommentField()}</td>
				<td>{editedProgress.id === 0 && renderUserSelector()}</td>
				<td>
					<div className="d-flex">
						{
							editedProgress.id === 0
								?
								<>
									<Button variant="primary" className="me-1" onClick={() => upsertProgress()}>{t('Save.label')}</Button>
									<Button variant="secondary"  onClick={() => setEditedProgress({ id: -1 })}>{t('Cancel.label')}</Button>
								</>
								:
								<Button variant="primary" className="mx-2" onClick={() => {
									setEditedProgress({
										id: 0,
										ownerId: companyId,
										userId: '',
										username: '',
										comment: '',
										date: '',
										progress: ''
									})
								}}>{t('New.label')}</Button>
						}
					</div>
				</td>
			</tr>
		);
	};

	const upsertProgress = () => {
		const pData = JSON.parse(JSON.stringify(editedProgress));
		if (!pData.id) delete pData.id;

		setLoaderDisplay(true);
		KPIService.upsertActionProgress(pData, editedAction.id).then(res => {
			setLoaderDisplay(false);
			if (res.status !== 200) return;

			setEditedProgress({ id: -1 });
			fetchActionProgress(editedAction.id);
		}).catch(err => {
			setLoaderDisplay(false);
		});
	};

	const deleteProgress = (id) => {
		KPIService.deleteActionProgress(id).then(res => {
			if (res.status !== 200) return;

			setProgressToDelete({ id: -1 });
			fetchActionProgress(editedAction.id);
		}).catch(err => { });
	};

	return (
		<div id='kpiActionsViewHolder_action'>
			<div className="row">
				<div className="col-md-4">
					<div className="actionDtView table-responsive">
						<Table responsive="sm" bordered>
							<thead>
								<tr>
									<th>{t("Actions.label")}</th>
								</tr>
							</thead>
							<tbody>
								{
									actions.map((action, aIndex) => {
										return (
											<tr key={`actionRow-${aIndex}`}
												className={editedAction && editedAction.id === action.id ? 'cursor bg-selected-row' : 'cursor'}
											>
												<td onClick={() => setEditedAction(action)} >
													{action.name}
												</td>
											</tr>
										)
									})
								}
							</tbody>
						</Table>
					</div>
				</div>
				<div className="col-md-8">
					<div className="table-responsive actionDtView">
						<Table responsive="sm" bordered >
							<thead>
								<tr>
									<th>{t("Date.label")}</th>
									<th>{t("ProgressPerc.label")}</th>
									<th>{t("Comments.label")}</th>
									<th>{t("UpdatedBy.label")}</th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								{
									actionProgressData.map((progress, pIndex) => {
										return (
											editedProgress?.id === progress.id
												? renderProgressRowInEditMode(pIndex)
												:
												<tr key={`actionProgressRow-${pIndex}`}>
													<td>{moment(progress.date).format('MMM DD, YYYY')}</td>
													<td>{progress.progress}</td>
													<td>{progress.comment}</td>
													<td>{progress.username}</td>
													<td>
														<Dropdown>
															<Dropdown.Toggle variant="blank_outline">
																<BsThreeDots className="m-0" />
															</Dropdown.Toggle>
															<Dropdown.Menu>
																<Dropdown.Item onClick={() => setEditedProgress(progress)}>{t("Edit.label")}</Dropdown.Item>
																<Dropdown.Item onClick={() => setProgressToDelete(progress)}>{t("Delete.label")}</Dropdown.Item>
															</Dropdown.Menu>
														</Dropdown>
													</td>
												</tr>
										);
									})
								}
								{editedAction.id > 0 && renderNewProgressRow()}
							</tbody>
						</Table>
					</div>
				</div>
			</div>
			{
				progressTodelete?.id > 0 &&
				<ConfirmationModal
					modalShow={true}
					messageText={t('DeleteActionProgressConfirmationMessage.label')}
					callbackModal={(val) => {
						deleteProgress(progressTodelete.id);
						setProgressToDelete({ id: -1 });
					}}
					confirmBtn={t("Confirm.label")}
					CancelBtn={t("Cancel.label")} />
			}
		</div>
	);
};

export default withTranslation()(KPIActionsView);
